<template>
  <section v-if="hasContent(context.item.modulinfotext3spaltigueberschrift)" :class="sectionClass">
    <div class="container">
      <h2 class="section-title info-2c-text__title">
        <span class="headline">{{ context.item.modulinfotext3spaltigueberschrift.value }}</span>
      </h2>
      <div class="row info-3c-text__row">
        <div class="column">
          <div class="text-block">
            <h3>{{ context.item.modulinfotext3spaltiguntertitel1 }}</h3>
            <span v-html="context.item.modulinfotext3spaltigtext1"></span>
          </div>
        </div>
        <div class="column">
          <div class="text-block">
            <h3>{{ context.item.modulinfotext3spaltiguntertitel2 }}</h3>
            <span v-html="context.item.modulinfotext3spaltigtext2"></span>
          </div>
        </div>
        <div class="column">
          <div class="text-block">
            <h3>{{ context.item.modulinfotext3spaltiguntertitel3 }}</h3>
            <span v-html="context.item.modulinfotext3spaltigtext3"></span>
          </div>
        </div>
      </div>
      <div class="center" v-if="hasContent(context.item.modulinfotext3spaltigbutton.text)">
        <a class="button button--cat1 button--large" :href="context.item.modulinfotext3spaltigbutton.url" :target="context.item.modulinfotext3spaltigbutton.target">{{ context.item.modulinfotext3spaltigbutton.text }}</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ModulInfoText3Spaltig',
  props: {
    context: {
      type: Object,
    },
  },
  computed: {
    sectionClass() {
      const styleField = this.context.item.modulinfotext3spaltigstyle;

      // Überprüfen, ob das Feld existiert und einen Wert hat
      if (styleField && styleField.trim()) {
        return `outer info-3c-text section-styling-${styleField}`;
      }

      // Standardklasse zurückgeben, wenn kein Feld vorhanden ist
      return 'outer info-3c-text section-styling-0'; 
    },
  },
  methods: {
    hasContent(fieldContent) {
      return fieldContent && fieldContent.trim().length > 0;
    },  
  },
};
</script>